import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from 'projects/Administration/src/app/business-entities/brand.model';
import { SpecialTools, SpecialToolType } from 'projects/Administration/src/app/business-entities/special-tool-model';
import { RentalCarService } from 'projects/Administration/src/app/business-services/rental-car.service';
import { SpecialToolBusinessService } from 'projects/Administration/src/app/business-services/special-tool.service';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../../business-entities/vehicle-list-view-model';
import { Constant } from '../../../../../../../Autofacets-Core/src/app/utils/constant'
import { CheckListBusinessService } from '../../../../business-services/check-list.service';

@Component({
  selector: 'app-add-special-tool',
  templateUrl: './add-special-tool.component.html',
  styleUrls: ['./add-special-tool.component.css']
})
export class AddSpecialToolComponent implements OnInit {

  specialTool: SpecialTools =
    {
      brandId: null,
      partNumber: "",
      enpartDescription: "",
      departDescription: "",
      nlpartDescription: "",
      partGroup: "",
      partImage: "",
      createdBy: "",
      pc: null,
      lcv: null,
      truck: null,
      imageBinaryData: "",
      mimeType: "",
      image: "",
      specialToolImage: "",
      languageCode: '',
      partDescription: '',
      id: 0
    };
  addSpecialTool = false;
  addSpecialToolForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  specialToolTypes: SpecialToolType[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private specialToolService: SpecialToolBusinessService,
    private router: Router, private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private activeModal : NgbActiveModal,
    private userService: UserDataService,
    private imageService:ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.addSpecialToolForm = this.formBuilder.group({
      brand: [null, [Validators.required]],
      partNumber: [''],
      partDescription: new FormArray([]),
      partGroup: [''],
      image: [''],
      isActive: [true],
      vehicletype:[null],
      specialToolTypeId:[null],
    });
    this.getBrandData();
    this.getLanguage();
    this.GetAllVehicleTypes();
    this.GetAllSpecialToolTypes();
  }

  get t() { return this.cpf.partDescription as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
  }
  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if(localStorage.getItem("Theme") == Constant.BnhInterface){
        this.vehicleTypes = data.responseObject;
      }
      else{
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  async getBrandData() {
    await this.GetAllBrand();
  }
  async GetAllSpecialToolTypes(): Promise<void> {
    await this.specialToolService.getAllSpecialToolTypes().then(data => {
      this.specialToolTypes = data.responseObject
    });
  }
  get cpf() {
    return this.addSpecialToolForm.controls;
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.specialTool.mimeType = files[0].type;
    this.specialTool.image = files[0].name;
    this.specialTool.specialToolImage="";
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormate=this.imageService.validateImageFormat(this.specialTool.mimeType);
    if(isValidFormate)
    {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.specialTool.imageBinaryData = reader.result.toString().replace('data:' + this.specialTool.mimeType + ';base64,', '');
        this.specialTool.specialToolImage = me.imageBaseData;
      };
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    reader.onerror = function (_error) {
      // This is intentional
    };
    this.spinner.hide();

  }
  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  addSpecialTools() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    const viewModel = {
      ...this.addSpecialToolForm.value,
      image: this.specialTool.image,
      mimeType: this.specialTool.mimeType,
      imageBinaryData: this.specialTool.imageBinaryData,
      createdBy: currentUser,
      brandId: this.brandList.find(x => x.brandCode === this.addSpecialToolForm.get('brand').value).id,
    }
    const isValidFormat=this.imageService.validateImageFormat(this.specialTool.mimeType);
    if(isValidFormat)
    {
      this.specialToolService.addEditSpecialTool(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.router.navigate(['specialTool']);
          let successMsg = this.translate.instant("lblSpecialToolAdded");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true });
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          let errorErr = this.translate.instant("lblSpecialToolExist");
          this.toaster.warning(errorErr);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    this.spinner.hide();
  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
}
